/**
 * A Floating UI anchor that survives its element being unmounted.
 *
 * Clicking outside the editor collapses the selection, which takes the bubble
 * menu — and any popover trigger composed into it — out of the DOM one frame
 * into the popup's exit animation. Floating UI resolves a missing anchor to
 * the top-left corner of the viewport, so the popup flashes there while it
 * fades. Holding the element's last measurement keeps it where it was.
 */
export const lastKnownRectAnchor = (getElement: () => Element | null) => {
  let lastRect: DOMRect | null = null;

  return () => ({
    getBoundingClientRect: () => {
      const element = getElement();
      if (element?.isConnected) {
        lastRect = element.getBoundingClientRect();
      }
      return lastRect ?? new DOMRect();
    },
  });
};
